<template>
	<el-container >
		<el-header class="title" >
			<el-row type="flex" align="middle">
				<el-col :span="22" >
					<el-breadcrumb separator-class="el-icon-arrow-right">
						<el-breadcrumb-item >首页</el-breadcrumb-item>
						<el-breadcrumb-item >组织配置信息管理</el-breadcrumb-item>
					</el-breadcrumb>
				</el-col>
			</el-row>
		</el-header>
		<el-main style="position: relative;" v-loading="loading">
			<el-form :style="mainStyleObject" label-suffix=" : " :rules="rules" :model="orgInfo" label-width="120px" size="medium" ref="form">
				<el-form-item label="公司名称" prop="name">
					<el-input v-model="orgInfo.name" style="width: 400px;" placeholder="请输入公司名称"></el-input>
				</el-form-item>
				<el-form-item label="公司LOGO" prop="logo">
					<el-upload class="avatar-uploader" :action="uploadUrl"  :show-file-list="false" v-loading="uploading"
										 :on-success="uploadSuccess" :on-error="uploadError" :before-upload="beforeUpload" >
						<img v-if="orgInfo.logo" :src="orgInfo.logo" class="avatar">
						<i v-else class="el-icon-plus avatar-uploader-icon"></i>
						<div style="font-size: 12px;">*  点击可上传公司LOGO</div>
					</el-upload>
				</el-form-item>
				<el-form-item label="公司地址">
					<el-input v-model="orgInfo.zcdzAddress" style="width: 400px;" placeholder="请输入公司地址"></el-input>
				</el-form-item>
				<el-form-item label="友情提示信息" >
					<el-input type="textarea" :rows="5" v-model="orgInfo.frontremind" placeholder="请输入H5前端提示信息" style="width: 400px;"></el-input>
				</el-form-item>
			</el-form>
			<div class="mobile-preview">
				<div class="iphone-view-x">
					<iframe id="dialogFrame" frameborder="0" scrolling="no" :src="iframeUrl"></iframe>
					<div class="phonebg"></div>
				</div>
			</div>
			<div class="mobile-intro">
				<div class="qrcode-image">
					<div style="font-size: 16px;line-height: 20px;margin-bottom: 20px;">移动端二维码</div>
					<el-image style="width: 140px;height: 140px;" :src="getRrcode"></el-image>
					<div>
						<!--<el-link type="primary" @click="copyLink()" :underline="true">复制移动端链接</el-link>-->
						<div style="font-size: 14px;line-height: 20px;word-break:break-all;padding: 5px 10px;">{{getFrontUrl}}</div>
						<span style="font-size: 12px;color: #F23946;font-weight: bold;line-height: 20px;">
							<i class="el-icon-info" style="margin-right: 2px;"></i>为了方便您固定客户端入口，可将此链接配置在您的微信公众号自定义菜单中，引导客户从微信公众号进行登录操作。
						</span>
					</div>
				</div>
			</div>
		</el-main>
		<div style="line-height: 40px;background:#fff;border-top: 1px solid #ddd;padding: 5px 10px 0 10px;">
			<el-button type="primary" size="small" @click="submitOrgInfo" style="width: 80px;">保存</el-button>
		</div>
	</el-container>
</template>

<script>
		import config from "../../../config/global.js";
		import axios from "axios"

		var getOrgInfoUrl = config.host+"/backend/org/get.json";
		var updateOrgInfoUrl = config.host + "/backend/org/update.json";

    export default {
        name: "org-config",
			data:function () {
				return {
					orgInfo:{frontremind:"",frontqrcode:"",frontURL:""},
					loading:false,
					uploading:false,
					uploadUrl:config.host+"/backend/uploadextfile",
					iframeUrl:config.host+"/frontend/pcpreviewsignin",
					rules: {
						name: [
							{required: true, message: '请输入公司名称', trigger: 'blur'},
							{min: 1, max: 50, message: '长度在 1 到 50 个字符', trigger: 'blur'}
						]
					},
					mainStyleObject:{
						"height":window.innerHeight-170+"px",
						"overflow-y":"auto",
						"padding":"20px 10px 10px 10px",
						"box-sizing":"border-box"
					}
				}
			},
			mounted:function () {
				this.getOrgInfo();
			},
			computed:{
				getRrcode:function () {
					if(this.orgInfo.frontqrcode == null || this.orgInfo.frontqrcode == "")
						return "";
					return this.orgInfo.frontqrcode;
				},
				getFrontUrl:function () {
					if(this.orgInfo.frontURL == null || this.orgInfo.frontURL == "")
						return "";
					return this.orgInfo.frontURL;
				}
			},
			methods:{
				getOrgInfo:function () {
					this.loading=true;
					axios({
						method: 'post',
						url:getOrgInfoUrl
					}).then((response)=>{
						var defaultResult = this.responseDefaultHandle(response);
						if(defaultResult == false )
							return;
						if(response.data.result == 1){
							this.orgInfo = response.data;
						}else{
							this.$alert(response.data.emsg, '请求失败', {
								confirmButtonText: '确定'
							});
						}
						this.loading = false;
					}).catch((error)=>{
						this.loading = false;
						this.$alert(error.response.statusText, '请求失败', {
							confirmButtonText: '确定'
						});
					})
				},
				submitOrgInfo:function () {
					this.loading = true;
					axios({
						method: 'post',
						url:updateOrgInfoUrl,
						data:this.orgInfo
					}).then((response)=>{
						var defaultResult = this.responseDefaultHandle(response);
						if(defaultResult == false )
							return;
						if(response.data.result == 1){
							this.$message({
								message: '保存成功',
								type: 'success'
							});
							//刷新IFrame页面
							this.iframeUrl = config.host+"/frontend/pcpreviewsignin?r"+Math.random();
						}else{
							this.$alert("提示", '保存失败', {
								confirmButtonText: '确定'
							});
						}
						this.loading = false;
					}).catch(()=>{
						this.loading = false;
						this.$alert("提示", '保存失败', {
							confirmButtonText: '确定'
						});
					})
				},
				beforeUpload:function (file) {
					this.uploading = true;
					return true;
				},
				uploadSuccess:function (response, file, fileList) {
					this.uploading = false;
					if(response.result == 1){
						this.orgInfo.logo = response.noticeFile.url;
					}else{
						this.$alert("上传失败,请重试", '提示', {
							confirmButtonText: '确定',
						})
					}
				},
				uploadError:function (event) {
					this.uploading = false;
					this.$message.error('上传失败,请重试');
				},
			}
    }
</script>

<style scoped>
	.title{
		border-bottom: 1px solid #ddd;
		padding: 10px;
	}

	.avatar-uploader .el-upload {
		border: 1px dashed #d9d9d9;
		border-radius: 6px;
		cursor: pointer;
		position: relative;
		overflow: hidden;
	}
	.avatar-uploader .el-upload:hover {
		border-color: #409EFF;
	}
	.avatar-uploader-icon {
		font-size: 28px;
		color: #8c939d;
		width: 178px;
		height: 178px;
		line-height: 178px;
		text-align: center;
	}
	.avatar {
		width: 178px;
		height: 178px;
		display: block;
	}

	.mobile-preview{
		position: absolute;
		left: 580px;
		top: 10px;
		transform: scale(0.6);
		transform-origin: 0% 0;
	}

	.iphone-view-x{
		width: 415px;
		height: 830px;
	}

	.iphone-view-x iframe {
		padding: 24px 25px 23px 25px;
		width: 100%;
		height: 100%;
		box-sizing: border-box;
	}

	.iphone-view-x .phonebg {
		background: url("https://imgmeet.oss-cn-shanghai.aliyuncs.com/images/iphonex.png");
		background-repeat: no-repeat;
		background-position: 0 0;
		background-size: 100%;
		position: absolute;
		top: 0px;
		left: 0px;
		width: 100%;
		height: 100%;
		pointer-events: none;
	}

	.qrcode-image{
		text-align: center;
		width: 300px;
	}

	.mobile-intro{
		position: absolute;
		left: 850px;
		top: 20px;
	}

</style>



// WEBPACK FOOTER //
// src/layouts/orgconfig/OrgConfig.vue